/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import {
  CompanyContainer,
  HeaderTitle,
  LoaderWrapper,
  StyledContainer,
  TableCell,
  TableWrapper,
  TwoColumns,
  IconButton,
} from '../../../services/settings/appStyle/global.style';
import GroupIcon from '@mui/icons-material/Group';
import CheckIcon from '@mui/icons-material/Check';
import {
  Table,
  IconButton as IconButtonWithText,
  Loader,
  TabButton,
} from '../../../Components/uielements';
import { useUserContext } from '../../../hooks/UserContext';
import LogbookService from '../../../services/bioplus-services/logBook';
import DocumentService from '../../../services/bioplus-services/document';
import DateUtils from '../../../utils/date-utils';
import { FilterMenuFieldV2 } from '../../../Components/uielements/filterMenuField';
import { extractData, getDeclarationQuestions } from './logHelper';
import { ClosedEyeGray, DownloadIcon, EyeIcon } from '../../../Components/icons';
import DeclarationModal from './declarationModalView';
import { IntlMessages } from '../../../helper/langHelper';
import { useIntl } from 'react-intl';
import moment from 'moment';
import { exportExcelFile } from '../../../helper/exportExcelHelper';
import { useCompany } from '../../../hooks/CompanyContext';
import { convertToUserTimeZone } from '../../../helper/dataFormat';

const getLogRecordsListBasedOnActiveTab = async (
  selectedTab,
  partnerId,
  companyFilter,
  startDate,
  endDate,
  page,
  pageSize
) => {
  if (selectedTab === 'Visited') {
    return await LogbookService.selfRecords(page, pageSize, companyFilter);
  } else if (selectedTab === 'Guests') {
    return await LogbookService.listByCompany(
      partnerId,
      {
        companyId: companyFilter,
        fromDate: startDate,
        toDate: endDate,
      },
      page,
      pageSize
    );
  }
};

const VisitorLogRecords = () => {
  const userContext = useUserContext();
  const userRole = userContext?.company;
  const companyId = userContext?.company?.companyId;

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [name, setName] = useState();
  const [startDate, setStartDate] = useState(DateUtils.last7Days);
  const [endDate, setEndDate] = useState(DateUtils.today);
  const [isDeclarationView, setIsDeclarationView] = useState(true);
  const [declarationData, setDeclarationData] = useState();
  const [selectedTab, setSelectedTab] = useState('Visited');

  const companyContext = useCompany();
  const partnerId = userContext?.company?.companyId?.id;
  const companyFilter = companyContext?.company?._id;
  // format language
  const intl = useIntl();
  const alertMessagedeclarationFailed = intl.formatMessage({
    id: 'help.text.declaration.error',
  });

  const query = useQuery(
    ['logBookEntries', partnerId, companyFilter, startDate, endDate, page, pageSize, selectedTab],
    () =>
      // LogbookService.listByCompany(
      //   userContext?.company?.companyId,
      //   {
      //     name: name,
      //     fromDate: startDate,
      //     toDate: endDate,
      //   },
      //   page,
      //   pageSize
      // )

      getLogRecordsListBasedOnActiveTab(
        selectedTab,
        partnerId,
        companyFilter,
        startDate,
        endDate,
        page,
        pageSize
      )
  );
  const tableData = query?.data ?? [];

  const handleNextPage = () => {
    setPage((value) => value + 1);
  };
  const handlePreviousPage = () => {
    setPage((value) => value - 1);
  };

  const handleFilterParams = (filterParams) => {
    if (filterParams) {
      const { fromDate, toDate } = filterParams;
      setStartDate(fromDate);
      setEndDate(toDate);
    }
  };

  const handleSelectedTab = (selectedTab) => {
    setSelectedTab(selectedTab);
  };

  const userTimeZone = useMemo(() => Intl.DateTimeFormat().resolvedOptions().timeZone, []);
  //   table coulmns
  const userColumns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.visitor.name" />,
        accessor: 'userName',
        Cell: (cellData) => (
          <TableCell>
            {`${cellData?.row?.original?.userId?.firstName} ${cellData?.row?.original?.userId?.lastName}`}
          </TableCell>
        ),
      },
      {
        Header: <IntlMessages id="table.col.company" />,
        accessor: 'companyId.name',
        // width: '22%',
      },
      {
        Header: <IntlMessages id="table.col.premise" />,
        accessor: 'premiseId.propertyName',
      },
      {
        Header: <IntlMessages id="table.col.geofence" />,
        accessor: 'geofenceId.name',
      },
      {
        Header: <IntlMessages id="table.col.service.role" />,
        accessor: 'serviceRole',
      },
      {
        Header: <IntlMessages id="table.col.entry.date" />,
        accessor: 'entryDate',
        Cell: (cellData) => (
          <TableCell>
            {cellData.value ? moment(cellData.value).format('DD-MM-YYYY') : '--'}
          </TableCell>
        ),
      },
      {
        Header: <IntlMessages id="table.col.entry.time" />,
        accessor: 'entryDate',
        Cell: (cellData) => (
          <TableCell>
            {cellData.value ? convertToUserTimeZone(cellData.value, userTimeZone) : '--'}
          </TableCell>
        ),
        id: 'entryTime',
      },
      {
        Header: <IntlMessages id="table.col.exit.time" />,
        accessor: 'exitDate',
        Cell: (cellData) => (
          <TableCell>
            {cellData.value ? convertToUserTimeZone(cellData.value, userTimeZone) : '--'}
          </TableCell>
        ),
      },
      {
        Header: <IntlMessages id="text.declaration" />,
        accessor: 'declaration',
        isAction: true,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleDeclarationLink = async (data) => {
    try {
      const content = await DocumentService.getDocument(data?.declarationId);
      const declarationContent = {
        ...content,
        geofenceName: data?.geofenceName,
        premise: data?.premiseName,
      };
      if (content && declarationContent) {
        // const declarationQuestionAnswer = getDeclarationQuestions(declarationContent);
        // if (declarationQuestionAnswer) {
        setDeclarationData(declarationContent);
        setIsDeclarationView(true);
        // }
      }
    } catch (error) {
      alert(alertMessagedeclarationFailed);
    }
  };

  const handleClosed = () => {
    setIsDeclarationView(false);
  };

  const actionList = [
    (data) => (
      <>
        {data?.declarationId ? (
          <IconButton onClick={() => handleDeclarationLink(data)}>
            <EyeIcon style={{ width: '18px', height: '18px' }} />
          </IconButton>
        ) : (
          <IconButton>
            <ClosedEyeGray style={{ width: '18px', height: '18px', color: 'red' }} />
          </IconButton>
        )}
      </>
    ),
  ];

  const excelFormatData = extractData(tableData);
  const fileName = 'logRecords.xlsx';
  const columnConfig = [
    { header: 'Visitor Name', key: 'VisitorName', width: 30 },
    { header: 'Entity Name', key: 'Company', width: 30 },
    { header: 'premise Name', key: 'premiseName', width: 30 },
    { header: 'Geofence Name', key: 'Geofence', width: 30 },
    { header: 'Service Role', key: 'serviceRole', width: 30 },
    { header: 'Date', key: 'Date', width: 20 },
    { header: 'Entry Time', key: 'entryTime', width: 20 },
    { header: 'Exit Time', key: 'exitTime', width: 20 },
  ];

  return (
    <StyledContainer>
      <CompanyContainer>
        <HeaderTitle>
          <IntlMessages id="nav.records.logRecords" />
        </HeaderTitle>
        <TwoColumns style={{ gap: '10px' }}>
          <TabButton
            buttonArray={[
              { buttonText: 'Visited', textId: '1', icon: <CheckIcon /> },
              { buttonText: 'Guests', textId: '2', icon: <GroupIcon /> },
            ]}
            onButtonClick={handleSelectedTab}
            selectedTab={selectedTab}
          />
          <FilterMenuFieldV2 handleFilterParams={handleFilterParams} isOnlyDate={true} />
          {excelFormatData && (
            <IconButtonWithText
              text={<IntlMessages id="button.text.downloadExcel" />}
              icon={<DownloadIcon />}
              onClick={() => exportExcelFile(excelFormatData, fileName, columnConfig)}
            />
          )}
        </TwoColumns>
      </CompanyContainer>
      {query.isLoading ? (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      ) : (
        <TableWrapper>
          <Table
            data={tableData}
            columns={userColumns}
            hasFooter={true}
            page={page}
            pageSize={pageSize}
            prevPage={handlePreviousPage}
            nextPage={handleNextPage}
            total={query?.data?.length || 0}
            actions={actionList}
          />
        </TableWrapper>
      )}
      {declarationData && (
        <DeclarationModal
          open={isDeclarationView}
          onClose={handleClosed}
          userData={declarationData}
        />
      )}
    </StyledContainer>
  );
};

export default VisitorLogRecords;
